import {
    BankDetailType,
    BankValidationResponse,
    CreateDirectDebitRequest,
    DirectDebitDetails,
    UpdateDirectDebitRequest
} from 'components/common/CommonTypes';
import { ApiHelper } from './apiHelper';
import {
    MissedPaymentRequest,
    MissedPaymentResponse,
    SuccessfulPaymentNotificationRequest,
    SuccessfulPaymentNotificationQueueResponse
} from './types/payment';

export class PaymentApi {
    validateDirectDebit(
        directDebitDetails: DirectDebitDetails,
        token: string,
        successCallback: (data: BankValidationResponse) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal
    ): void {
        const dataUrl = '/api/payment/directdebit';
        new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            directDebitDetails,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
    UpdateDirectDebit(
        updatedirectdebit: UpdateDirectDebitRequest,
        token: string,
        successCallback: (data: BankValidationResponse) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal
    ): void {
        const dataUrl = '/api/payment/updatedirectdebit';
        new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            updatedirectdebit,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
    CreateDisbursement(
        createDisbursement: CreateDirectDebitRequest,
        token: string,
        successCallback: (data: BankValidationResponse) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal
    ): void {
        const dataUrl = '/api/payment/createdisbursement';
        new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            createDisbursement,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
    GetDirectDebit(
        policyReference: string,
        token: string,
        successCallback: (result: BankDetailType) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal
    ): void {
        const query = encodeURI(`?policyreference=${policyReference}`);
        const dataUrl = '/api/payment/getdirectdebit' + query;
        new ApiHelper().getDataSecureAsync(
            dataUrl,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }

    sendOrder(
        token: string,
        policyReference,
        callback: (data: MissedPaymentResponse) => void,
        failureCallback: () => void,
        signal?: AbortSignal
    ): void {
        const dataUrl = `/api/payment/processmissedpayment`;

        const data: MissedPaymentRequest = {
            policyReference
        };

        new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            data,
            token,
            callback,
            failureCallback,
            signal
        );
    }

    notifySuccessfulPayment(
        token: string,
        request: SuccessfulPaymentNotificationRequest,
        callback: (data: SuccessfulPaymentNotificationQueueResponse) => void,
        failureCallback: () => void,
        signal?: AbortSignal
    ): void {
        const dataUrl = `/api/payment/successfulpayment`;

        new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            request,
            token,
            callback,
            failureCallback,
            signal
        );
    }
}
